import React from 'react';
import HazardsTab from '../components/HazardsTab';

export default function Hazards() {
  return <HazardsTab />;
}